import React, { useCallback, useEffect, useMemo, useState } from "react";
import useEvent from "react-use/lib/useEvent";
import styled, { css } from "styled-components";
import { defaultColor, selectedColor } from "../../../helpers/color";
import scrollbar from "../../../helpers/scrollbar";
import textSize from "../../../helpers/textSize";
import Arrow from "../../Assets/Icons/Arrow";
import List from "../../Data/List";
import Flex from "../../Layout/Flex";
import Panel from "../../Layout/Panel";
import Input from "../Input";
export const sizes = {
  tiny: css(["line-height:25px;"]),
  small: css(["line-height:32px;"]),
  default: css(["line-height:42px;"])
};
function size({
  size
}) {
  return sizes[size] || sizes.default;
}
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1js0j6a-0"
})(["position:relative;width:100%;"]);
const StyledSelect = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledSelect",
  componentId: "sc-1js0j6a-1"
})(["display:flex;align-items:center;color:", ";cursor:pointer;&:hover{color:", ";}"], defaultColor, selectedColor);
const Selected = /*#__PURE__*/styled.div.withConfig({
  displayName: "Selected",
  componentId: "sc-1js0j6a-2"
})(["", " ", " width:85%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], size, textSize);
const Options = /*#__PURE__*/styled(Panel).withConfig({
  displayName: "Options",
  componentId: "sc-1js0j6a-3"
})(["", " position:absolute;z-index:3;top:100%;left:0;right:10px;max-height:160px;"], scrollbar);
const StyledArrow = /*#__PURE__*/styled(Arrow).withConfig({
  displayName: "StyledArrow",
  componentId: "sc-1js0j6a-4"
})(["margin-left:auto;"]);
export default function Select({
  value,
  options,
  search,
  arrow,
  children,
  placeholder,
  autoFocus,
  onChange,
  ...props
}) {
  const [active, setActive] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const selected = useMemo(() => (options.find(o => o.value === value) || {}).label, [options, value]);
  const searchable = useMemo(() => options.map(option => {
    return {
      ...option,
      search: option.label.toLowerCase() || ""
    };
  }), [options]);
  const filtered = useMemo(() => searchValue ? searchable.filter(o => o.search.includes(searchValue.toLowerCase())) : searchable, [searchable, searchValue]);
  const onBlur = useCallback(() => setActive(false), []);
  const onClick = useCallback(e => {
    e.stopPropagation();
    setActive(active => !active);
  }, []);
  const onSearch = useCallback(e => setSearchValue(e.target.value), []);
  const onClickItem = useCallback(value => {
    onChange(value);
    setSearchValue("");
  }, [onChange]);
  useEffect(() => {
    if (autoFocus) setActive(true);
  }, [autoFocus]);
  useEvent("click", active && onBlur);
  return /*#__PURE__*/React.createElement(Root, props, active && search && /*#__PURE__*/React.createElement(Input, {
    size: "small",
    autoFocus: true,
    placeholder: placeholder,
    onChange: onSearch
  }) || /*#__PURE__*/React.createElement(StyledSelect, {
    onClick: onClick
  }, children || /*#__PURE__*/React.createElement(Selected, null, selected || placeholder), arrow && /*#__PURE__*/React.createElement(StyledArrow, {
    size: 16
  })), active && filtered.length > 0 && /*#__PURE__*/React.createElement(Options, null, /*#__PURE__*/React.createElement(List, null, filtered.map(({
    value,
    label
  }) => /*#__PURE__*/React.createElement(List.Item, {
    key: value,
    onClick: () => onClickItem(value)
  }, /*#__PURE__*/React.createElement(Flex, {
    padding: 10
  }, label))))));
}
Select.displayName = "Select";
//# sourceMappingURL=index.js.map